<template>
  <div class="input-field" :id="target">
    <div class="label">{{ label }}</div>
    <div v-if="!!tooltip" class="icon"></div>
    <select
      :disabled="disabled()"
      @change="update"
      v-if="type==='select'"
      v-bind:class="classObject"
      v-bind:style="styleObject"
    >
      <option v-for="(month,index) of months" v-bind:key="index" :value="month">{{ month}}</option>
    </select>
    <datepicker
      :disabled="disabled()"
      :format="datePickerFormater"
      @selected="updateDatePicker"
      v-else-if="type==='date'"
      :value="value"
    ></datepicker>
    <input
      :disabled="disabled()"
      v-else
      @change="update"
      v-bind:class="classObject"
      v-bind:style="styleObject"
      :value="value"
    />
    <div class="error" v-if="error()">
      {{ state.ERRORS[target].reduce((accum, item, index, array) => {
      accum = accum + item;
      if (index !== array.length -1){
      accum = accum + ',';
      }
      return accum;
      } , '')}}
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  methods: {
    error() {
      if (typeof this.state.ERRORS === "undefined") return false;

      if (Object.keys(this.state.ERRORS).length === 0) return false;
      return typeof this.state.ERRORS[this.target] !== "undefined";
    },
    disabled() {
      if (typeof this.state.ERRORS === "undefined") return false;
      if (Object.keys(this.state.ERRORS).length === 0) return false;
      if (typeof this.state.ERRORS[this.target] !== "undefined") return false;
      return true;
    },
    datePickerFormater(date) {
      return moment(new Date(date)).format(this.dateFormat);
    },
    keyup(e) {
      this.input(e);
    },
    updateDatePicker(e) {
      const value = moment(new Date(e));
      this.update({
        target: {
          parentNode: {
            id: this.target
          },
          value
        }
      });
    }
  },

  computed: {
    ...mapState({
      state: state => state.base
    }),
    dateFormat: function() {
      if (this.format) return this.format;
      return "MMMM DD, YYYY";
    },
    styleObject: function() {
      if (this.prefix) {
        return { backgroundImage: `url('${this.prefix}')` };
      }
      if (this.suffix) {
        return { backgroundImage: `url('${this.suffix}')` };
      }
    },
    classObject: function() {
      if (
        typeof this.prefix === "undefined" &&
        typeof this.suffix === "undefined"
      )
        return { disabled: this.disabled(), noPrefixOrSuffix: true };
      if (this.prefix) {
        return { disabled: this.disabled(), prefix: this.prefix };
      }
      if (this.suffix) {
        return { disabled: this.disabled(), suffix: this.suffix };
      }
    }
  },

  props: [
    "label",
    "target",
    "value",
    "tooltip",
    "suffix",
    "prefix",
    "update",
    "type",
    "months",
    "format"
  ],
  components: {
    Datepicker
  }
};
</script>

<style scope lang="scss">
.input-field {
  font-family: "Open Sans", sans-serif;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .label {
    font-size: 14px;
    color: #282828;
    margin-bottom: 6px;
  }
  .icon {
    background-image: url("../../../public/info.svg");
    width: 18px;
    height: 18px;
    background-size: contain;
    margin-bottom: 6px;
  }
  .error {
    font-size: 12px;
    color: red;
    position: absolute;
    top: 64px;
    @media (min-width: 768) {
      top: 70px;
    }
  }
  input,
  select,
  .vdp-datepicker {
    font-family: "Open Sans", sans-serif;
    height: 40px;
    width: 100%;
    background-size: 8px;
    background-repeat: no-repeat;
    background-position-x: 10px;
    background-position-y: center;
    border-style: solid;
    border-color: #e1e1e1;
    border-width: 1px;
  }
  input,
  select {
    box-sizing: border-box;
  }
  .disabled {
    background-color: #e1e1e1 !important;
  }
  .vdp-datepicker {
    input {
      cursor: pointer;
    }
  }
  select {
    cursor: pointer;
    background-size: 24px;
    background-color: white;
    -webkit-appearance: none;
  }
  .vdp-datepicker {
    div {
      border: none;
      input {
        border: none;
        padding-left: 10px;
      }
    }
    .vdp-datepicker__calendar {
      font-family: sans-serif;
      font-size: 14px;
      color: #282828;
    }
  }
  .prefix {
    padding-left: 24px;
    background-position-x: 10px;
  }
  .suffix {
    padding-right: 24px;
    padding-left: 10px;
    background-position-x: calc(100% - 10px);
  }
  .noPrefixOrSuffix {
    padding-left: 10px;
  }

  .rtl {
    direction: rtl;
  }

  .vdp-datepicker {
    position: relative;
    text-align: left;
  }

  .vdp-datepicker * {
    box-sizing: border-box;
  }

  .vdp-datepicker__calendar {
    position: absolute;
    z-index: 100;
    background: #fff;
    width: 300px;
    border: 1px solid #ccc;
  }

  .vdp-datepicker__calendar header {
    display: block;
    line-height: 40px;
  }

  .vdp-datepicker__calendar header span {
    display: inline-block;
    text-align: center;
    width: 71.42857142857143%;
    float: left;
  }

  .vdp-datepicker__calendar header .prev,
  .vdp-datepicker__calendar header .next {
    width: 14.285714285714286%;
    float: left;
    text-indent: -10000px;
    position: relative;
  }

  .vdp-datepicker__calendar header .prev:after,
  .vdp-datepicker__calendar header .next:after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    border: 6px solid transparent;
  }

  .vdp-datepicker__calendar header .prev:after {
    border-right: 10px solid #000;
    margin-left: -5px;
  }

  .vdp-datepicker__calendar header .prev.disabled:after {
    border-right: 10px solid #ddd;
  }

  .vdp-datepicker__calendar header .next:after {
    border-left: 10px solid #000;
    margin-left: 5px;
  }

  .vdp-datepicker__calendar header .next.disabled:after {
    border-left: 10px solid #ddd;
  }

  .vdp-datepicker__calendar header .prev:not(.disabled),
  .vdp-datepicker__calendar header .next:not(.disabled),
  .vdp-datepicker__calendar header .up:not(.disabled) {
    cursor: pointer;
  }

  .vdp-datepicker__calendar header .prev:not(.disabled):hover,
  .vdp-datepicker__calendar header .next:not(.disabled):hover,
  .vdp-datepicker__calendar header .up:not(.disabled):hover {
    background: #eee;
  }

  .vdp-datepicker__calendar .disabled {
    color: #ddd;
    cursor: default;
  }

  .vdp-datepicker__calendar .flex-rtl {
    display: flex;
    width: inherit;
    flex-wrap: wrap;
  }

  .vdp-datepicker__calendar .cell {
    display: inline-block;
    padding: 0 5px;
    width: 14.285714285714286%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    vertical-align: middle;
    border: 1px solid transparent;
  }

  .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,
  .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,
  .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {
    cursor: pointer;
  }

  .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
  .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
  .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
    border: 1px solid #4bd;
  }

  .vdp-datepicker__calendar .cell.selected {
    background: #4bd;
  }

  .vdp-datepicker__calendar .cell.selected:hover {
    background: #4bd;
  }

  .vdp-datepicker__calendar .cell.selected.highlighted {
    background: #4bd;
  }

  .vdp-datepicker__calendar .cell.highlighted {
    background: #cae5ed;
  }

  .vdp-datepicker__calendar .cell.highlighted.disabled {
    color: #a3a3a3;
  }

  .vdp-datepicker__calendar .cell.grey {
    color: #888;
  }

  .vdp-datepicker__calendar .cell.grey:hover {
    background: inherit;
  }

  .vdp-datepicker__calendar .cell.day-header {
    font-size: 75%;
    white-space: nowrap;
    cursor: inherit;
  }

  .vdp-datepicker__calendar .cell.day-header:hover {
    background: inherit;
  }

  .vdp-datepicker__calendar .month,
  .vdp-datepicker__calendar .year {
    width: 33.333%;
  }

  .vdp-datepicker__clear-button,
  .vdp-datepicker__calendar-button {
    cursor: pointer;
    font-style: normal;
  }

  .vdp-datepicker__clear-button.disabled,
  .vdp-datepicker__calendar-button.disabled {
    color: #999;
    cursor: default;
  }
}
</style>